import React from "react";
import { Col, Row } from "react-bootstrap";
import { ActionHandlerFunction, AdminDashboardUser, Sort } from "@preveil-api";
import { AdminUIActionTypes, DashboardUsage, SORT_DIRECTION } from "src/common";
import { EmptyView, Icon, Loading } from "src/components";
import { ListRow } from ".";
import _ from "lodash";

type AllProps = {
  is_loading: boolean;
  users_list: AdminDashboardUser[];
  sort: Sort<keyof AdminDashboardUser>;
  handleAction: ActionHandlerFunction;
}

function ListViewComponent(props: AllProps) {
  const { is_loading, users_list, sort, handleAction } = props;
  const total_private_usage = _.sumBy(users_list, "private_usage");
  const total_shared_storage = _.sumBy(users_list, "shared_storage");
  const total_file_count = _.sumBy(users_list, "file_count");

  // Description: Render the rows of Admin Users view
  function RenderList(_list: AdminDashboardUser[]) {
    return (
      <div className="list-body">
        {_.map(_list, (_user: AdminDashboardUser, i: number) => {
          return (
            <ListRow
              key={`item_${i}`}
              user={_user}
            />
          );
        })}
      </div>
    );
  }

  // Description: Render the footer row
  function RenderFooterRow() {
    return <Row className="footer-row">
      <Col md="3">Totals</Col>
      <Col md="3">{DashboardUsage.convertUsageToFriendlySizeList(total_private_usage)}</Col>
      <Col md="3">{DashboardUsage.convertUsageToFriendlySizeList(total_shared_storage)}</Col>
      <Col md="2">{total_file_count}</Col>
    </Row>;
  }

  // Descriptions: Shareable react fragment - for each field - returns the header with sort icon
  function headerWithSortIcon(name: string, field: string) {
    const length = users_list.length;
    return (
      <>
        {name}
        {!!sort && sort.field === field && length > 0 && (
          <Icon className={`${sort.direction === SORT_DIRECTION.descending ? "ficon-arrow-down" : "ficon-arrow-up"} small-icon ps-1`} />
        )}
      </>
    );
  }

  // Description: Handles Sorting
  function handleSort(field: string) {
    handleAction({ actionType: AdminUIActionTypes.SetSort, params: field });
  }

  return <div className={`admin-list-view admin-dashboard ${is_loading ? " isloading" : ""}`}>
    {!!users_list && users_list.length > 0 && (
      <Row className="header-row">
        <Col md="3" className="col" onClick={() => handleSort("display_name")}>{headerWithSortIcon("Name", "display_name")}</Col>
        <Col md="3" className="col" onClick={() => handleSort("private_usage")}>{headerWithSortIcon("Individual Usage", "private_usage")}</Col>
        <Col md="3" className="col" onClick={() => handleSort("shared_storage")}>{headerWithSortIcon("Shared Storage", "shared_storage")}</Col>
        <Col md="2" className="col" onClick={() => handleSort("file_count")}>{headerWithSortIcon("File Count", "file_count")}</Col>
      </Row>
    )}
    {!!users_list && users_list.length > 0 ? (
      <>
        {RenderList(users_list)}
        {RenderFooterRow()}
      </>
    ) : !is_loading ? <EmptyView message="No matches found!" /> : null}

    {is_loading && <Loading />}
  </div>;
}

export default React.memo(ListViewComponent);